import {
    IChainInfo,
    IExtraProduct,
    IExtraProductGroup,
    IInteriorProduct,
    IInteriorProductGroup,
    IInteriorProductSubGroup,
    IProductLine
} from "../models/IChainInfo";
import { ChainInfoClient } from "./WebApiClient";


export class ChainInfoService {

    constructor(private readonly client: ChainInfoClient) {

    }

    async getChainInfo(): Promise<IChainInfo> {
        var dtoCi = await this.client.getChainInfo();
        const extraProducts = dtoCi.extraProducts.map(dtoPg => {
            const ps = [] as IExtraProduct[];
            const pg = {
                ...dtoPg,
                products: ps,
            } as IExtraProductGroup;
            for (let dtoP of dtoPg.products) {
                const p = {
                    ...dtoP,
                    productGroup: pg,
                } as IExtraProduct;
                ps.push(p);
            }
            return pg;
        });

        return {
            ...dtoCi,
            logoUrl: dtoCi.logoUrl ?? undefined,
            cssUrl: dtoCi.cssUrl ?? undefined,
            extraProducts,
            productLines: dtoCi.productLines.map(dtoPl => {
                const interiorProducts = dtoPl.interiorProducts.map(dtoPg => {
                    const psgs = [] as IInteriorProductSubGroup[];
                    const pg = {
                        ...dtoPg,
                        interiorProductSubGroups: psgs
                    } as IInteriorProductGroup;
                    for (let dtoPsg of dtoPg.interiorProductSubGroups) {
                        const ps = [] as IInteriorProduct[];
                        const psg = {
                            ...dtoPsg,
                            productGroup: pg,
                            products: ps
                        } as IInteriorProductSubGroup;
                        for (let dtoP of dtoPsg.products) {
                            const p = {
                                ...dtoP,
                                productSubGroup: psg
                            } as IInteriorProduct;
                            ps.push(p);
                        }

                        psgs.push(psg);
                    }
                    return pg;
                });
                
                const result: IProductLine = {
                    ...dtoPl,
                    adapterMaterials: dtoPl.adapterProducts.flatMap(p => p.materials),
                    interiorProducts,
                    imageUrl: dtoPl.imageUrl ?? undefined
                };
                return result;
            })
        }
    }
}
